import React, { ReactNode, useMemo } from 'react';

import { NavigationAdminConfiguration } from '../types';
import {
    NavigationAdminConfigurationContext,
    NavigationAdminConfigurationContextType,
    defaultNavigationAdminConfiguration,
} from './NavigationAdminConfigurationContext';

export interface NavigationAdminConfigurationProviderProps extends NavigationAdminConfigurationContextType {
    configuration: NavigationAdminConfiguration;
    children: ReactNode;
}

/**
 * Provider to use the Navigation Admin Configuration Context
 */
export const NavigationAdminConfigurationProvider: React.FC<NavigationAdminConfigurationProviderProps> = ({
    defaultFeeds,
    configuration,
    children,
}) => {
    const value = useMemo(
        () => ({
            ...defaultNavigationAdminConfiguration,
            defaultFeeds,
            hasFilters:
                configuration.availableFilters &&
                Object.values(configuration.availableFilters).filter((isEnabled) => isEnabled).length > 0,
            ...configuration,
        }),
        [defaultFeeds, configuration],
    );

    return (
        <NavigationAdminConfigurationContext.Provider value={value}>
            {children}
        </NavigationAdminConfigurationContext.Provider>
    );
};
